import React from 'react';
 
const toObject = ({ name, type, children }) => 
{   
    if (type !== 'script') return null;
    if (!name || name !== 'script') return null;
    if (!Array.isArray(children)) return null;

    const jsonPurified = children[0]?.data.replace(/[;\r\n]/g, '');
    return <script type="application/ld+json">{JSON.stringify(JSON.parse(jsonPurified))}</script>;
};

export default toObject;